import Vue from "vue";

Vue.component("static-content-video", {
	props: [ "code" ],
	data() {
		return {
			videoList: [],
			loadingText: window.labels.loading,
			loading: true,
			autoOpened: false
		};
	},
	methods: {
		getContent: function () {
			this.loading = true;
			this.$services.staticVideos.getContent({
				code: this.code,
				language: window.currentLanguageInt
			}).then((data) => {
				this.videoList = data;
				this.loading = false;
				this.maybeAutoOpen();
			});
		},
		getVideoIdParam: function () {
			const raw = new URL(window.location.href).searchParams.get("videoId");
			const parsed = parseInt(raw, 10);
			return Number.isNaN(parsed) ? null : parsed;
		},
		maybeAutoOpen: function () {
			if (this.autoOpened) return;
			const targetId = this.getVideoIdParam();
			if (targetId === null) return;
			if (!this.videoList || this.videoList.length === 0) return;

			const index = this.videoList.findIndex((v) => v.videoId === targetId);
			if (index === -1) return;

			this.autoOpened = true;
			const realId = this.videoList[index].id;
			// Append &x= so the lightbox's fixed "?showinfo=0" suffix becomes
			// the value of x rather than a second query-string opener.
			// Resulting URL: ...REALID?autoplay=1&mute=1&x=?showinfo=0
			this.videoList[index].id = realId + "?autoplay=1&mute=1&x=";

			this.$nextTick(() => {
				if (this.$refs.viewer) {
					this.$refs.viewer.openGallery(index);
				}
			});
		},
		writeUrl: function (search) {
			const url = new URL(window.location.href);
			const qs = search.toString();
			window.history.replaceState({}, "", qs ? url.pathname + "?" + qs : url.pathname);
		},
		onVideoChanged: function (videoId) {
			if (videoId === undefined || videoId === null) return;
			const search = new URL(window.location.href).searchParams;
			search.set("videoId", videoId);
			this.writeUrl(search);
		},
		onVideoClosed: function () {
			const search = new URL(window.location.href).searchParams;
			search.delete("videoId");
			this.writeUrl(search);
		}
	},
	mounted() {
		this.getContent();
	},
	template: `
      <div v-if="loading">
      		<loading loading-text="loadingText"></loading>
      </div>
	  <div v-else-if="!loading && videoList && videoList.length > 0">
	  	<wto-video-viewer ref="viewer" :media="videoList" @video-changed="onVideoChanged" @video-closed="onVideoClosed"></wto-video-viewer>
	  </div>
	`
});
